
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/metal-resources/metal-market-intelligence/podcast/[slug]",
      function () {
        return require("private-next-pages/metal-resources/metal-market-intelligence/podcast/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/metal-resources/metal-market-intelligence/podcast/[slug]"])
      });
    }
  